import axios from 'axios';
import { AWSWrapper } from '../aws.js';

// Client for the "chat with your data" backend (Express routes in
// heroku-start.js). Calls are same-origin (/api/chat/*), so in production they
// hit the Express server that serves the app; in local `npm start` they are
// forwarded by CRA's dev proxy (see package.json "proxy").
const api = axios.create({
  baseURL: '/api/chat',
  timeout: 60000, // 60s — QBO fetch + LLM round-trip can be slow
});

/**
 * Send a chat message about a company's QuickBooks data.
 * @param {string} message       The user's question.
 * @param {string} realmId       The selected company's realmId.
 * @param {Array<{role:string,content:string}>} history  Recent turns for context.
 * @returns {Promise<{response:string, context_used:string|null}>}
 */
export async function sendChatMessage(message, realmId, history = []) {
  const idToken = await AWSWrapper.getFreshIdToken();
  if (!idToken) {
    throw new Error('Your session expired. Please log in again.');
  }
  localStorage.setItem('GStoken', idToken);

  const { data } = await api.post(
    '/send',
    { message, realmId, history },
    { headers: { 'Content-Type': 'application/json', Authorization: idToken } },
  );
  return data;
}

// Prefix for per-company conversation history persisted in localStorage.
export const CHAT_HISTORY_PREFIX = 'gs_chat_msgs_';

/**
 * Remove all locally-stored chat conversations. Call on logout so a shared
 * machine doesn't retain a user's financial Q&A.
 */
export function clearAllChatHistory() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.indexOf(CHAT_HISTORY_PREFIX) === 0) keys.push(key);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch (e) { /* storage disabled — non-fatal */ }
}
